export const timelineClassNames = {
  timeStamp: 'timeline-time-stamp',
  timeItemContainer: 'timeline-item-container',
  pointWrapper: 'timeline-point',
  lineComponent: 'timeline-line',
  eventContainer: 'timeline-event',
}

export const mockData = [
  {
    date: {
      dateFormatted: 'Dec, 04 2023',
      eventTime: '11:00 AM',
      isCheckIn: false,
      isCheckOut: true,
      isFuture: false,
    },
    events: [
      {
        id: 'abdcc6e6-765e-11ee-a76e-5bb1d1b0416b',
        bookingId: 'ca1b24aa-7658-11ee-9357-1d22bc36d2f4',
        time: '2023-10-29T13:25:47.744580Z',
        kind: 'ADDED_GUEST',
        author: {
          internal: false,
          name: 'James D’Angelo',
        },
        data: {
          booking: null,
          payment: null,
          guest: {
            personId: 'ab792290-765e-11ee-8b25-6d35868d5948',
            name: 'Janine Guill',
            email: 'guilljanine@gmail.com',
            phone: null,
          },
          operationsCase: null,
          idVerificationStatusChanged: null,
          contractStatusChanged: null,
          serviceRequest: null,
          refund: null,
          item: null,
        },
        previousData: {
          booking: null,
          payment: null,
          guest: null,
          operationsCase: null,
          idVerificationStatusChanged: null,
          contractStatusChanged: null,
          serviceRequest: null,
          refund: null,
          item: null,
        },
      },
    ],
  },
  {
    date: {
      dateFormatted: 'Dec, 01 2023',
      eventTime: '04:00 PM',
      isCheckIn: true,
      isCheckOut: false,
      isFuture: false,
    },
    events: [
      {
        id: '842eb06a-905b-11ee-8e87-0fc5edc406de',
        bookingId: 'ca1b24aa-7658-11ee-9357-1d22bc36d2f4',
        time: '2023-12-01T15:08:42.914154Z',
        kind: 'INSTRUCTIONS_SENT',
        author: {
          internal: true,
          name: 'System',
        },
        data: {
          booking: null,
          payment: null,
          guest: null,
          operationsCase: null,
          idVerificationStatusChanged: null,
          contractStatusChanged: null,
          serviceRequest: null,
          refund: null,
          item: null,
        },
        previousData: {
          booking: null,
          payment: null,
          guest: null,
          operationsCase: null,
          idVerificationStatusChanged: null,
          contractStatusChanged: null,
          serviceRequest: null,
          refund: null,
          item: null,
        },
      },
    ],
  },
  {
    date: {
      dateFormatted: 'Oct, 29 2023',
      eventTime: '10:25 AM',
      isCheckIn: false,
      isCheckOut: false,
      isFuture: false,
    },
    events: [
      {
        id: 'ca327d43-7658-11ee-a76e-75e544b6b964',
        bookingId: 'ca1b24aa-7658-11ee-9357-1d22bc36d2f4',
        time: '2023-10-29T12:43:41.657370Z',
        kind: 'RESERVATION_CREATED',
        author: {
          internal: true,
          name: 'System',
        },
        data: {
          booking: {
            period: {
              start: '2023-12-01',
              end: '2023-12-04',
            },
            home: {
              name: 'Ben Lippen - Bradford',
            },
            guests: 2,
            total: 64699,
            emails: null,
            phones: null,
            guestName: null,
          },
          payment: null,
          guest: null,
          operationsCase: null,
          idVerificationStatusChanged: null,
          contractStatusChanged: null,
          serviceRequest: null,
          refund: null,
          item: null,
        },
        previousData: {
          booking: null,
          payment: null,
          guest: null,
          operationsCase: null,
          idVerificationStatusChanged: null,
          contractStatusChanged: null,
          serviceRequest: null,
          refund: null,
          item: null,
        },
      },
      {
        id: 'ca28440f-7658-11ee-a76e-8b0c32371a5f',
        bookingId: 'ca1b24aa-7658-11ee-9357-1d22bc36d2f4',
        time: '2023-10-29T12:43:41.590535Z',
        kind: 'ITEMS_SYNCED',
        author: {
          internal: true,
          name: 'System',
        },
        data: {
          booking: null,
          payment: null,
          guest: null,
          operationsCase: null,
          idVerificationStatusChanged: null,
          contractStatusChanged: null,
          serviceRequest: null,
          refund: null,
          item: null,
        },
        previousData: {
          booking: null,
          payment: null,
          guest: null,
          operationsCase: null,
          idVerificationStatusChanged: null,
          contractStatusChanged: null,
          serviceRequest: null,
          refund: null,
          item: null,
        },
      },
    ],
  },
]
